import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class ClientsFetchAPI {

       static async getClientType( token) {
        const res = await server(`/clients_types`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getClientsByBusiness(business_id, token) {
        const res = await server(`/client/${business_id}/business_clients`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getClientsById(client_id, token) {
        const res = await server(`/client/${client_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async createClient(data, token) {
        const res = await server(`/client`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async loginClientForBusiness(data, token) {
        const res = await server(`/auth/loginclient`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getFrecuentShopperPointsTransactions(client_id, token) {
        const res = await server(`/frequent-shopper/client/${client_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async manageFrequentShopperPoints(client_id, data, token) {
        const res = await server(`/frequent-shopper/client/${client_id}`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async createAddressClient(data, token) {
        const res = await server(`/direction/client`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getAddressClient(client_id, token) {
        const res = await server(`/direction/client?client_id=${client_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async getAddressById(direction_id, token) {
        const res = await server(`/direction?direction_id=${direction_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async deleteAddressClient(direction_id, token) {
        const res = await server(`/direction/client?direction_id=${direction_id}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res
    }

    static async updateAddressClient(direction_id, data, token) {
        const res = await server(`/direction/client?direction_id=${direction_id}`, {
            method: "put",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

      static async updateClient(data, client_id, token) {
        const res = await server(`/client/${client_id}`, {
            method: "put",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }
}